import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MinaMeddelandenService } from './mina-meddelanden.service';
import { fadeInAnimation } from '../_animations/fade-in.animation'
import { Subscription } from 'rxjs';
import { InformationRequest } from '../interfaces/informationRequest.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../session/session.service';

@Component({
    selector: 'app-mina-meddelanden',
    templateUrl: './mina-meddelanden.component.html',
    styleUrls: ['./mina-meddelanden.component.scss'],
    animations: [
        fadeInAnimation
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MinaMeddelandenComponent {
  constructor(
    protected service: MinaMeddelandenService,
    protected spinner: NgxSpinnerService,
    protected sessionService: SessionService,
    protected route: ActivatedRoute,
    protected router: Router) {
  }
  public filterText: string;
  public order: string = 'status.namn';
  public reverse: boolean = false;
  public previousArendeId: string;
  public subscription: Subscription;
  public minaRequests: InformationRequest[];

  public get isLoaded() { return !!this.minaRequests };

  public ngOnInit() {
    this.loadMinaRequests();
  }

  public ngOnDestroy(): void {
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public userFilter: any;

  public applyFilter(): void {
    this.userFilter = {
      $or: [
        { case: this.filterText }, 
        { dateString: this.filterText },       
        { requestFirm: this.filterText },
        { about: this.filterText },      
        { statusString: this.filterText }     
      ]
    };
  }

  private loadMinaRequests() {
    const doLoad = () => {
      setTimeout(() => {
          if (!this.minaRequests) {
            this.spinner.show();
          }
        },
        300);

      this.service.getMinaInfoRequests(this.sessionService.activeInstance.id).subscribe(
        result => {
          this.spinner.hide();

          this.minaRequests = result
            .map(req => {
              const dateString = new Intl.DateTimeFormat('sv-SE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).format(new Date(req.date));
              
              const statusString = req.answered ? 'request-answered' : 'request-waiting-response';

              return {
                ...req,
                dateString,
                statusString
              };
            })
            .sort((t1, t2) => new Date(t2.date).getTime() - new Date(t1.date).getTime());
        }
      );
    };

    if (!this.sessionService.hasSession) {
      this.router.navigate(['/login']);
      return;
    }

    doLoad();
  }

  public setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }
}
